import type { IGatsbyImageData } from 'gatsby-plugin-image';

export type SanityImageType = Partial<
  Omit<Queries.SanityImageType, 'asset'>
> & {
  asset?: {
    gatsbyImageData?: IGatsbyImageData;
  };
};

export interface ImageProps {
  gatsbyImageData: IGatsbyImageData;
  alt: string;
  caption?: string;
}

export const getSanityImageProps = (image: SanityImageType): ImageProps => {
  if (!image?.alt) throw new Error('Expected sanity image to have alt text');
  if (!image?.asset?.gatsbyImageData)
    throw new Error('Expected valid sanity gatsby image data asset');

  return {
    caption: image?.caption || undefined,
    alt: image.alt,
    gatsbyImageData: image.asset.gatsbyImageData,
  };
};
